import React from "react";

interface QuickAccessCardProps {
  icon: string;
  title: string;
  dropdownIcon: string;
  className?: string;
}

export const QuickAccessCard: React.FC<QuickAccessCardProps> = ({
  icon,
  title,
  dropdownIcon,
  className,
}) => {
  return (
    <article
      className={`flex relative flex-col flex-1 shrink items-start px-4 py-5 bg-white rounded-xl border border-solid shadow-sm basis-0 border-[color:var(--Colors-Border-border-secondary,#EAECF0)] hover:shadow-md hover:-translate-y-1 transition-all cursor-pointer ${className || ""}`}
    >
      <div className="flex w-full justify-between items-center mb-2">
        <img 
          src={icon} 
          alt="" 
          className="w-6 h-6 object-contain"
        />
        <img 
          src={dropdownIcon} 
          alt="" 
          className="w-4 h-4 object-contain"
        />
      </div>
      <h3 className="text-sm font-semibold text-gray-900 mt-2">{title}</h3>
    </article>
  );
};
